import { MenuItems } from '@menu-lib/components/AppLayout/MainMenu/menuItems';
import { MenuItemRegistry } from '@menu-lib/components/AppLayout/MainMenu/menuRegistry';
import { type EnvironmentSettings, type LinkItem } from '@menu-lib/components/AppLayout/types';

MenuItemRegistry.register(MenuItems.Werkvoorraad, {
  isVisible: (settings: EnvironmentSettings) => settings.isInterneGebruiker,
  create: (): LinkItem => ({
    itemtype: 'link',
    menuItem: MenuItems.Werkvoorraad,
    title: 'Werkvoorraad',
    url: '/net/rapportageintern/werkvoorraad',
    iconclass: 'fas fa-box',
  }),
});
